module.exports = __webpack_public_path__ + "img/Example02.78311522.png";